module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright-index"
  }, [_c('xi-top'), _vm._v(" "), _c('div', {
    staticClass: "banner-out-wrapper"
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "anchor_banner_bg.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner-inner-wrapper"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "large-slogan"
  }, [_vm._v("海量优质内容等你来播讲")]), _vm._v(" "), _c('span', {
    staticClass: "sub-slogan"
  }, [_vm._v("让你的好声音持续被发现")]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [(!_vm.isAnchor) ? _c('a', {
    attrs: {
      "href": ("" + (_vm.$store.state.ANCHOR_AUTH_URL)),
      "target": "_blank"
    }
  }, [_vm._v("主播认证")]) : _c('a', {
    attrs: {
      "href": ((_vm.$store.state.A_PC_HOST) + "/requirementview")
    }
  }, [_vm._v("去参加海选")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "gain-out-wrapper"
  }, [_c('div', {
    staticClass: "gain-inner-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("丰富的收益模式")]), _vm._v(" "), _c('div', {
    staticClass: "gain-pattern"
  }, [_c('div', {
    staticClass: "pattern"
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "commission_logo.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("录制佣金")])]), _vm._v(" "), _c('div', {
    staticClass: "pattern"
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "gain_share_logo.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("收益分成")])]), _vm._v(" "), _c('div', {
    staticClass: "pattern"
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "fans_sponsor_logo.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("粉丝赞助")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "channels-out-wrapper"
  }, [_c('div', {
    staticClass: "channels-inner-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("找作品读")]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "addition_logo.png")
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "tags_logo.png")
    }
  }), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "best-anchor-out-wrapper"
  }, [_c('div', {
    staticClass: "best-anchor-inner-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("优秀主播")]), _vm._v(" "), _c('div', {
    staticClass: "anchors"
  }, [_c('div', {
    staticClass: "anchor"
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "top_anchor_1.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("有声的紫襟")]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("签约主播")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "2014年6月签约平台，截止目前共录制63张专辑，累计粉丝320万",
      "placement": "top",
      "popper-class": "desc-popper"
    }
  }, [_c('p', {
    staticClass: "big-desc"
  }, [_vm._v("\n                                2014年6月签约平台，截止目前共录制63张专辑，累计粉丝320万\n                            ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "anchor"
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "top_anchor_2.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("剧舞吧小宇宙")]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("签约主播")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "2015年12月开始录制第一张专辑，截止目前共录制15张专辑，累计粉丝14万",
      "placement": "top",
      "popper-class": "desc-popper"
    }
  }, [_c('p', {
    staticClass: "big-desc"
  }, [_vm._v("\n                                2015年12月开始录制第一张专辑，截止目前共录制15张专辑，累计粉丝14万\n                            ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "anchor"
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "top_anchor_4.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("丸子")]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("签约主播")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "2015年6月开始录制有声书，截止目前共录制10张专辑，累计粉丝100万",
      "placement": "top",
      "popper-class": "desc-popper"
    }
  }, [_c('p', {
    staticClass: "big-desc"
  }, [_vm._v("\n                                2015年6月开始录制有声书，截止目前共录制10张专辑，累计粉丝100万\n                            ")])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "help-center-out-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'anchorAboutPlatform'
      }
    }
  }, [_vm._v("如您还有更多疑问请查看帮助中心")]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-right-arrow-white icon-16",
    staticStyle: {
      "position": "relative",
      "top": "3px"
    }
  })], 1), _vm._v(" "), _c('xi-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("参加海选")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("参加播讲任务选拔，按照任务要求录制一段声音样本并提交。任务发布者会在参选声音样本中，挑选优秀的主播来完成有声书录制。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("丰富资料")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("编辑您喜欢或擅长播讲的类型作为声音标签并上传声音样本。这样能让您的好声音容易被发现，同时获得更多推荐播讲的机会。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ed025bb6!./~/vue-loader/lib/selector.js?type=template&index=0!./views/anchor/AnchorIndex.vue
// module id = 339
// module chunks = 0